import React, { Fragment } from 'react';
import { useController, ApplicationView as view } from '@aha-app/mvc';
import FieldPreview from './FieldPreview';
import DraggableFieldPreview from '../dnd/DraggableFieldPreview';
import ItemList from 'javascripts/dnd/components/ItemList';
import styles from './styles.module.css';
import type CustomField from '../models/CustomField';
import type CardLayoutEditorController from '../controllers/CardLayoutEditorController';

type CustomFieldPreviewProps = {
  // A CustomFieldDefinition being previewed.
  customField: CustomField;
};

const CustomFieldPreview: React.FC<CustomFieldPreviewProps> = ({
  customField,
}) => {
  const controller = useController<CardLayoutEditorController>();

  return (
    <Fragment>
      <dt>{customField.title}</dt>
      <dd className={styles.fieldSet}>
        <ItemList
          items={[customField]}
          createDraggableItem={customField =>
            new DraggableFieldPreview({
              controller,
              item: customField,
            })
          }
          listKey={`CustomFieldPreview-${customField.key}`}
          hideDragPreviews={false}
          ItemComponent={FieldPreview}
        />
      </dd>
    </Fragment>
  );
};

export default view(CustomFieldPreview);
